/* ===========================
IMPORTS
=========================== */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalCreate extends Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  */
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      description: '',
      errors: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    this.props.updateLoadingModal(false);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    this.props.handleSubmit(true);
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles`,
      'post',
      JSON.stringify({
        name: this.state.name,
        description: this.state.description,
      }),
      // callback
      () => {
        this.props.handleSubmitSuccess();
      },
      // failback
      (error) => {
        this.setState({
          errors: error,
        }, () => {
          this.props.handleSubmit(false);
        });
      },
    );

    event.preventDefault();
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <form id={this.props.id} onSubmit={this.handleSubmit}>
              <div className="form-group">
                <input onChange={this.handleChange} className="form-control" type="text" placeholder="Name" name="name" disabled={this.props.submitted} value={this.state.name} />
              </div>
              <div className="form-group">
                <textarea onChange={this.handleChange} className="form-control" placeholder="Description" name="description" disabled={this.props.submitted} value={this.state.description} />
              </div>

              {(this.state.errors && Object.keys(this.state.errors).length > 0)
                ? (
                  <div className="form-group">
                    <div className="alert alert-danger">
                      <ul>
                        {(Object.keys(this.state.errors).map((item) => (
                          <li key={`list-${item}`}>
                            <strong>{item}</strong>
                            {' '}
                            -
                            {' '}
                            {this.state.errors[item]}
                          </li>
                        )))}
                      </ul>
                    </div>
                  </div>
                )
                : null}

              {(this.props.submitted)
                ? (<Loader />)
                : null}
              <button type="submit" aria-label="submit" style={{ display: 'none' }} disabled={this.props.submitted} />
            </form>
          )
          : null}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalCreate.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalCreate;
